/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Checkinflyerdescription2Inputs */

const en_checkinflyerdescription2 = /** @type {(inputs: Checkinflyerdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Print it for the entrance, the bar and the tables, or share it as a story.`)
};

const de_checkinflyerdescription2 = /** @type {(inputs: Checkinflyerdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Druck ihn für Eingang, Bar und Tische aus oder teil ihn als Story.`)
};

/**
* | output |
* | --- |
* | "Print it for the entrance, the bar and the tables, or share it as a story." |
*
* @param {Checkinflyerdescription2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const checkinflyerdescription2 = /** @type {((inputs?: Checkinflyerdescription2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Checkinflyerdescription2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_checkinflyerdescription2(inputs)
	return de_checkinflyerdescription2(inputs)
});
export { checkinflyerdescription2 as "checkinFlyerDescription" }